export const PLUGIN_NAME = 'ecommerce-stripe-fe';
export const PAYMENT_PROVIDER_KEY = 'blaze-stripe';
export const COMPONENT_PREFIX = 'blaze-ecommerce-stripe';
